<template>
  <el-dialog 
    :visible.sync="show" 
    width="500px" 
    :close-on-click-modal="judgeClose" 
    :close-on-press-escape="judgeClose"
    :show-close="false"
    title="提示"
    center>
    <div style="text-align:center">
      <div style="margin-bottom:40px">{{judgeText}}</div>
      <el-button @click="clickButton()" size="small" type="primary">{{judgeButton}}</el-button>
      <el-button plain v-if="judgeClose" @click="closeButton()" size="small">我知道了</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props:{
    show:{
      type: Boolean,
      default: false
    },
    judgeText:{
      type: String,
      default: "您还没有创建门店，请先去创建门店"
    },
    judgeButton:{
      type: String,
      default: "前往创建"
    },
    judgeClose:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      
    }
  },
  methods:{
    clickButton(){
      this.$emit('gotoNext');
    },
    closeButton(){
      this.$emit('close');
    }
  }
}
</script>